import { StyleSheet } from 'aphrodite';
import { charmGray, error, successGreen, warningDark } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	row: {
		borderBottom: `1px solid ${charmGray}`,
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.1)', // 10% black opacity for light tint
		},
	},
	cell: {
		padding: '12px 16px',
		verticalAlign: 'middle',
	},
	contactInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
	},
	contactName: {
		fontWeight: 500,
		fontSize: '14px',
	},
	companyName: {
		fontSize: '12px',
	},
	callTime: {
		fontSize: '14px',
	},
	duration: {
		fontSize: '14px',
		fontFamily: 'monospace',
	},
	transcriptionStatus: {
		fontSize: '12px',
		fontWeight: 500,
		padding: '4px 8px',
		borderRadius: '12px',
		textAlign: 'center',
		minWidth: '80px',
	},
	statusAvailable: {
		backgroundColor: '#e8f5e8',
		color: successGreen,
	},
	statusProcessing: {
		backgroundColor: '#fff4e6',
		color: warningDark,
	},
	statusFailed: {
		backgroundColor: '#ffeaea',
		color: error,
	},
	statusUnavailable: {
		backgroundColor: '#f5f5f5',
		color: charmGray,
	},
	noAnalysisText: {
		color: 'rgba(255, 255, 255, 0.6)', // More transparent white for disabled text
		fontSize: '12px',
		fontStyle: 'italic',
	},
	sdrName: {
		fontSize: '14px',
	},
	callOutcome: {
		fontSize: '12px',
		fontWeight: 500,
		padding: '4px 8px',
		borderRadius: '12px',
		textAlign: 'center',
		minWidth: '80px',
		border: '1px solid',
	},
	copyButton: {
		backgroundColor: 'rgba(255, 255, 255, 0.1)',
		border: '1px solid rgba(255, 255, 255, 0.3)',
		borderRadius: '4px',
		color: 'white',
		fontSize: '12px',
		padding: '4px 8px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.2)',
		},
	},
	copyButtonDisabled: {
		backgroundColor: 'transparent',
		border: '1px solid rgba(255, 255, 255, 0.1)',
		color: 'rgba(255, 255, 255, 0.3)',
		cursor: 'not-allowed',
	},
	callTypeBadge: {
		fontSize: '10px',
		fontWeight: 600,
		padding: '2px 6px',
		borderRadius: '4px',
		textTransform: 'uppercase',
		letterSpacing: '0.5px',
		marginLeft: '8px',
		display: 'inline-block',
	},
	practiceCallBadge: {
		backgroundColor: '#e6f3ff',
		color: '#0066cc',
		border: '1px solid #0066cc40',
	},
});
